var scroll = {
	lock : function(stat) {
		if (stat == true) {
			if ($(window).scrollTop() != 0) {
				$('html, body').animate({ scrollTop: "0px"}, 300, function() {
					$('#container').addClass('sticky').css({'top' : 0});
					$.fn.scroller.lockScroll(true);
				});
			} else {
				$('#container').addClass('sticky').css({'top' : 0});
				$.fn.scroller.lockScroll(true);
			}
		} else {
			$('#container').removeClass('sticky').removeAttr('style');
			$(window).scrollTop(0);
			$.fn.scroller.lockScroll(false);
		}
	},
	header: {
		active: false,
		items: {},
		init: function() {
			if ( $( '.js-header' ).length  > 0) {
				scroll.header.active = true;
				scroll.header.getItems();
			}
		},
		getItems : function() {
			if ( scroll.header.active) {
				scroll.header.items = {
					$this: $( '.js-header' ),
					$nav: $( '.js-main-nav' ),
					changed: false,
					sticky: false,
				}
			}
		},
		calculation: function(pos) {
			if (scroll.header.active) {
				if ( pos.current.top == 0 ) {
					scroll.header.changed = false;
				} else if ( pos.current.top >= 80 ) {
					scroll.header.changed = true;
					scroll.header.sticky = true;
				} else {
					scroll.header.changed = false;
				}
			}
		},
		animation: function() {
			if (scroll.header.active) {
				if (scroll.header.changed) {
					if (scroll.header.sticky) {
						scroll.header.items.$nav.addClass('sticky');
					} else {
						scroll.header.items.$nav.removeClass('sticky');
					}
				} else {
					scroll.header.items.$nav.removeClass('sticky');
				}
			}
		},
		resize: function() {
			// ...
		},
	},
	filter: {
		active: false,
		items: {},
		init: function() {
			if ( $( '.home .js-filter' ).length > 0) {
				scroll.filter.active = true;
				scroll.filter.getItems();
			}
		},
		getItems : function() {
			if ( scroll.filter.active ) {
				scroll.filter.items = {
					$this: $( '.js-filter' ),
					$filterSpacer: $( '.filter-spacer' ),
					sticky: false,
				};
			}
		},
		fixIt: function() {
			var windowH = $( window ).height();
			var filterPos = scroll.filter.items.$filterSpacer.offset().top + scroll.filter.items.$filterSpacer.height();
			if ( windowH < filterPos ) {
				scroll.filter.items.$this.addClass( 'fixed' ).icons.init('.svg-icon');
			}
		},
		unFixIt: function() {
			scroll.filter.items.sticky = false;
			scroll.filter.items.$this.removeClass( 'fixed' );
		},
		calculation: function(pos) {
			if ( scroll.filter.active ) {
				var windowH = $( window ).height();
				if ( pos.current.top >= scroll.filter.items.$filterSpacer.offset().top - windowH + scroll.filter.items.$filterSpacer.height() ) {
					scroll.filter.items.sticky = false;
				} else {
					scroll.filter.items.sticky = true;
				}
			}
		},
		animation: function() {
			if ( scroll.filter.active ) {
				if (scroll.filter.items.sticky) {
					scroll.filter.fixIt();
				} else {
					scroll.filter.unFixIt();
				}
			}
		},
		resize: function() {
			// ...
		},
	},
}
